import React, { useState, useEffect } from "react";
import { Tabs, Table, Space, Spin, Tooltip, Button } from "antd";
import { serialNum } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { camelCase } from "../../../utils";
import { getPremiseId } from "../../../utils/worker";
import urls from "../../../api/urls";
import API from "../../../api";
import printerIcon from "../../../assests/images/print-manifest.svg";
import "./style.scss";
const CpWiseManifest = () => {
  const { GET_CP_WISE_MANIFEST } = urls;
  let premiseId = getPremiseId();
  const navigate = useNavigate();
  const [allCps, setAllCps] = useState();
  const [manifestDetails, setManifestDetails] = useState();
  const [loading, setLoading] = useState(false);
  let tempCps = allCps?.response?.data;
  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      key: "manifestId",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
    },
    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <span>{camelCase(text)}</span>,
    },
    {
      title: "No of Shipment(s)",
      dataIndex: "shipmentNum",
      key: "shipmentNum",
    },
    {
      title: "No of Packet(s)",
      dataIndex: "packetNum",
      key: "packetNum",
    },
    {
      title: "Total Weight (Kg)",
      dataIndex: "totalweight",
      key: "totalweight",
    },
    {
      title: "Action",
      key: "action",
      render: (text) => (
        <Space size="middle">
          <Button onClick={() => actionHandle(text)}>
            <Tooltip title="Print">
              <img src={printerIcon} />
            </Tooltip>
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getCPDetails();
  }, []);

  useEffect(() => {
    const filteredData = tempCps?.manifestedcp?.filter(
      (data) => data?.premiseName === tempCps?.cpdetails[0]?.premiseName
    );
    setManifestDetails(filteredData);
  }, [allCps]);

  const getCPDetails = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_CP_WISE_MANIFEST + premiseId?.split("Bearer ")[1]
    ).getWithHeader();
    if (response.status) {
      setLoading(false);
      setAllCps(response);
    } else {
      setLoading(false);
    }
  };
  const actionHandle = (e) => {
    navigate("/print-consolidated-manifest/" + e.manifestId);
  };
  const onChangeHandle = (e) => {
    const filteredData = tempCps?.manifestedcp?.filter(
      (data) => data?.premiseName === e?.toUpperCase()
    );
    setManifestDetails(filteredData);
  };
  return (
    <div className="cp-wise-manifest-cntr">
      <div className="header">CP Wise Manifest</div>
      <Spin spinning={allCps?.status ? false : true}>
        {allCps?.status ? (
          <Tabs
            className="cp-tab"
            defaultActiveKey="1"
            type="card"
            size={"small"}
            onChange={onChangeHandle}
            items={tempCps?.cpdetails?.map((a) => {
              return {
                label: camelCase(a?.premiseName),
                key: camelCase(a?.premiseName),
                children: (
                  <Table
                    loading={loading}
                    columns={columns}
                    dataSource={manifestDetails}
                    pagination={false}
                  />
                ),
              };
            })}
          />
        ) : (
          <Table
            loading={loading}
            columns={columns}
            dataSource={null}
            pagination={false}
          />
        )}
      </Spin>
    </div>
  );
};

export default CpWiseManifest;
